import { formatMoney } from 'src/common/currency';
import type { BillingDetail } from 'src/secret-menu/billing/hooks/useBilling';

/** The back end works out each firm's category; these only name and colour it. */
export type PricingCategory = BillingDetail['pricingCategory'];

export const PRICING_CATEGORY_ORDER: PricingCategory[] = [
  'TRIAL',
  'DISCOUNTED',
  'FIXED',
  'STANDARD',
];

export const PRICING_CATEGORY_LABELS: Record<PricingCategory, string> = {
  TRIAL: 'Free trial',
  DISCOUNTED: 'Discounted pricing',
  FIXED: 'Fixed fee',
  STANDARD: 'Standard pricing',
};

export const PRICING_CATEGORY_COLORS: Record<PricingCategory, string> = {
  TRIAL: 'blue',
  DISCOUNTED: 'orange',
  FIXED: 'grape',
  STANDARD: 'green',
};

export const PRICING_CATEGORY_RULES: Record<PricingCategory, string> = {
  TRIAL:
    'Not billing yet: no billing start date, one still to come, or no price set. This comes first, so a firm with a price agreed but not started is a trial.',
  DISCOUNTED: 'Billing per family at less than £5 a family.',
  FIXED:
    'Billing a flat monthly fee, or only a minimum with no per-family price. A per-family firm held up by its minimum stays per family.',
  STANDARD: 'Billing per family at £5 or more a family.',
};

const pounds = (amount: number) => formatMoney(amount, 'GBP');

export function describePricing(detail: BillingDetail): string {
  let base = 'No price set';
  if (detail.billingAmount !== null) {
    base =
      detail.billingType === 'FIXED'
        ? `${pounds(detail.billingAmount)} a month, fixed`
        : `${pounds(detail.billingAmount)} per family`;
  }
  return detail.minimumBillingAmount === null
    ? base
    : `${base} · ${pounds(detail.minimumBillingAmount)} minimum`;
}
